export const dedupeErrors = (errors: Array<undefined | { message?: string }>) => {
  const seen = new Set<string>()
  const result: Array<{ message?: string }> = []
  for (const error of errors) {
    if (!error?.message || seen.has(error.message)) continue
    seen.add(error.message)
    result.push(error)
  }
  return result
}
